import { I04CONSCHAUFAN_State } from '@batical/types/src'

const I04CONSCHAUFAN: I04CONSCHAUFAN_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_deperdition: 100.0,
  dju_uuid: '5B4BCA76-0A95-4785-AF49-ABEC268F6E87',
  in_tempExtBase: 3.0,
  in_temperatureAmbiante: 19.0,
  res_consoAnnuelle: 450.0,
  in_nbJourChauffe: 120.0,
  in_nombreHeureReduit: 0.0,
  in_nombreDegreAbaisse: 0.0,
  res_intermittence: 0.0,
  dataChart: [],
  mode: 'none',
  calcul_code: 'I04CONSCHAUFAN'
}

export default I04CONSCHAUFAN
